module.exports = __webpack_public_path__ + "img/nav-1.04f20ad1.png";